import React from 'react'
import { Header } from '../components/Header'
import Navbar from '../components/Navbar'
import SocialForm from '../components/SocialForm'
import Video from '../components/Video'

function Contact() {
  return (
    <div className='page'>
        <Header heading="Contact Us"></Header>
        <SocialForm/>
        <Navbar/>
    </div>
  )
}

export default Contact